import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";

import { BaseLayoutComponent } from "./Layout/base-layout/base-layout.component";

import { DashboardComponent } from "./Pages/dashboard/dashboard.component";
import { LoginBoxedComponent } from "./Pages/login-boxed/login-boxed.component";
import { CompanyRegistrationComponent } from "./Pages/company-registration/company-registration.component";
import { UserManagementComponent } from "./Pages/user-management/user-management.component";
import { ForgotPasswordComponent } from "./Pages/forgot-password/forgot-password.component";
import { ProjectDetailComponent } from "./Pages/project-detail/project-detail.component";
import { ScreenDetailComponent } from "./Pages/screen-detail/screen-detail.component";
import { ScreenDetailEditComponent } from "./Pages/screen-detail-edit/screen-detail-edit.component";
import { CanDeactivateGuard } from "./guards/can-deactivate.guard";
import { AdminGuard } from "./guards/admin.guard";
import { ThankyouPageComponent } from "./Pages/thankyou-page/thankyou-page.component";
import { SetPasswordComponent } from "./Pages/set-password/set-password.component";
import { TranslationComponent } from "./Pages/translation/translation.component";
import { AuditlogComponent } from "./Pages/audit-log/auditlog.component";
import { TranslatorGuard } from "./guards/translator.guard";
import { SuperAdminGuard } from "./guards/superadmin.guard";
import { ActiveLicensesComponent } from "./Pages/active-licenses/active-licenses.component";
import { AddRenewLicenseComponent } from "./Pages/add-renew-license/add-renew-license.component";
import { PaymentPlansComponent } from "./Pages/payment-plans/payment-plans.component";
import { TransactionDetailComponent } from "./Pages/transaction-detail/transaction-detail.component";
import { UsageAnaylticsComponent } from "./Pages/usage-anayltics/usage-anayltics.component";
import { TokenExpiredComponent } from "./Pages/token-expired/token-expired.component";
import { ListOfAllCompaniesComponent } from "./Pages/list-of-all-companies/list-of-all-companies.component";
import { LiveprojectsComponent } from "./Pages/liveprojects/liveprojects.component";
const routes: Routes = [
  {
    path: "page",
    component: BaseLayoutComponent,
    children: [
      { path: "dashboard", component: DashboardComponent },

      { path: "usage-analytics", component: UsageAnaylticsComponent },
      { path: "usage-analytics/:id", component: UsageAnaylticsComponent },
      {
        path: "user-management",
        component: UserManagementComponent,
        canActivate: [AdminGuard],
      },
      {
        path: "project-management/:id",
        component: ProjectDetailComponent,
        canDeactivate: [CanDeactivateGuard],
      },
      {
        path: "project-detail/:id",
        loadComponent: () =>
          import("./Pages/screen-detail/screen-detail.component").then(
            (c) => c.ScreenDetailComponent
          ),

        // component: ScreenDetailComponent
      },

      // { path: "project-detail/:id/:tabId", component: ScreenDetailComponent },
      /*   {
        path: "project-detail-edit/:pid/:sid/:tabId",
        component: ScreenDetailEditComponent,
      }, */
      {
        path: "project-detail-edit/:pid/screens/:sid/:tabId",
        component: ScreenDetailEditComponent,
      },
      {
        path: "translation/:pid/:tabId",
        component: TranslationComponent,
        canActivate: [TranslatorGuard],
      },
      {
        path: "auditlog/:pid",
        component: AuditlogComponent,
      },
      { path: "transaction-detail/:id", component: TransactionDetailComponent },
      // { path: "active-license", component: ActiveLicensesComponent },
      { path: "project-license-information", component: LiveprojectsComponent },
      {
        path: "project-license-history",
        component: ActiveLicensesComponent,
      },

      {
        path: "list-of-companies",
        component: ListOfAllCompaniesComponent,
        canActivate: [SuperAdminGuard],
      },

      {
        path: "add-renew-license",
        component: AddRenewLicenseComponent,
        canActivate: [SuperAdminGuard],
      },
    ],
  },

  { path: "verify-user", component: TokenExpiredComponent },
  { path: "payment-plan", component: PaymentPlansComponent },
  { path: "company-registration", component: CompanyRegistrationComponent },
  { path: "forgot-password", component: ForgotPasswordComponent },
  { path: "login", component: LoginBoxedComponent },
  { path: "thankyou-page/:id", component: ThankyouPageComponent },
  { path: "set-password", component: SetPasswordComponent },
  { path: "verify-user/set-password", component: SetPasswordComponent },
  // { path: "token-expired", component: TokenExpiredComponent },
  { path: "", component: LoginBoxedComponent },
  { path: "**", redirectTo: "/" },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      scrollPositionRestoration: "enabled",
      anchorScrolling: "enabled",
      onSameUrlNavigation: "reload",
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
